<template>
  <div class="settings-wrp" :key="route.path">
    <div class="settings-title">
      {{ t('Referral Program') }}
    </div>
    <div class="settings-content">
      <ui-tabs styleType="style-list" :tabs="tabs">
        <template #content-invitedUsers>
          <invited-users />
        </template>
        <template #content-referralBalance>
          <referral-balance />
        </template>
      </ui-tabs>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from '@/composables';
import InvitedUsers from './forms/invited-users.vue';
import ReferralBalance from './forms/referral-balance.vue';

const route = useRoute();
const { t } = useI18n();

const tabs = computed(() => [
  {
    label: t('Invited Users'),
    key: 'invitedUsers',
  },
  {
    label: t('Referral Balance'),
    key: 'referralBalance',
  },
]);
</script>

<style lang="scss" scoped>
</style>
